export default __webpack_public_path__ + "static/tick-c3c0ec9548cfc67a9c05092c3a88227f.png";